module.exports = __webpack_public_path__ + "img/plus.fbcff910.svg";